import { Loader } from 'common/components/Loader/Loader';
import { Suspense } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import routes from './routes';
import { Helmet } from 'react-helmet';
import ProtectedRoute from './ProtectedRoute';

const AppRoutes = () => {
  return (
    <Router>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Gu-music</title>
      </Helmet>
      <Suspense fallback={<Loader />}>
        <Routes>
          {routes.map(
            ({ path, page: Page, layout: Layout, permission }, index) => (
              <Route
                key={index}
                path={path}
                element={
                  <ProtectedRoute isPrivate={permission}>
                    {Layout ? (
                      <Layout>
                        <Page />
                      </Layout>
                    ) : (
                      <Page />
                    )}
                  </ProtectedRoute>
                }
              />
            )
          )}
        </Routes>
      </Suspense>
    </Router>
  );
};

export default AppRoutes;
